import { Injectable } from '@angular/core';
import { LoggerService } from './logger.service';
import { ConfirmDeleteDialogComponent } from 'src/app/components/confirm-delete-dialog/confirm-delete-dialog.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';



var TAG = "CustomConfirmDialogService";

@Injectable({
    providedIn: 'root'
})
export class CustomConfirmDialogService {

    constructor(private log: LoggerService,
        private modalService: NgbModal

    ) { }

    openDialog(action: string, tableKeyValue: string, data: any) {
        // console.log('open Dialog');
        this.log.d(TAG, 'open Dialog ,action = ' + action + " , tableKeyValue = " + tableKeyValue);
        const modalRef = this.modalService.open(ConfirmDeleteDialogComponent, { centered: true,backdrop: "static" });

        modalRef.componentInstance.action = action;
        modalRef.componentInstance.tableKeyValue = tableKeyValue;
        // modalRef.componentInstance.displayMsg = this.getDisplayMsg(tableKeyValue);
        modalRef.componentInstance.data = data;

        return modalRef;

    }



   

}

